<template>
  <div class="page">
    <BookingBack title="Change Password" :textColor="'#333333'" :isCenter="true" />
    <div class="content">
      <van-field v-model="oldPassword" placeholder="Please enter current password" type="password" autocomplete="current-password" />
      <van-field v-model="password" placeholder="Please enter new password" type="password" autocomplete="new-password" />
      <van-field v-model="confirm" placeholder="Confirm new password" type="password" autocomplete="new-password" />
    </div>
    <div class="footer">
      <van-button block color="#1E3C3E" @click="submit">Confirm</van-button>
    </div>
  </div>
</template>
<script>
import BookingBack from '@/components/Booking/back.vue'
import { editPassword } from '@/api'
export default {
  name: 'AccountPassword',
  components: { BookingBack },
  data() {
    return { oldPassword: '', password: '', confirm: '' }
  },
  methods: {
    submit() {
      if (!this.oldPassword) {
        this.$toast && this.$toast('Please enter current password')
        return
      }
      if (!this.password) {
        this.$toast && this.$toast('Please enter new password')
        return
      }
      if (this.password !== this.confirm) {
        this.$toast && this.$toast('Passwords do not match')
        return
      }
      const payload = {
        old_password: this.oldPassword,
        password: this.password,
        confirm_password: this.confirm
      }
      editPassword(payload)
        .then(res => {
          // 后端约定 code === 1 成功，其它按拦截器处理
          if (res && res.code === 1) {
            this.$toast && this.$toast('Updated successfully')
            this.$router.go(-1)
          }
        })
        .catch(() => {})
    }
  }
}
</script>
<style lang="scss" scoped>
.page { min-height: 100vh; background: #f5f7fa; }
.content { padding: 1rem; display: flex; flex-direction: column; gap: .5rem; }
.footer { position: fixed; left: 0; right: 0; bottom: 1rem; padding: 0 1rem; }
</style>
